module.exports = __webpack_public_path__ + "static/media/mountains-new-zealand.5b09fa0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/mountains-new-zealand.jpg
// module id = 157
// module chunks = 0